<template>
  <vs-popup
    title="New block time"
    :active.sync="config.isActive"
    id="view-block-time-popup"
    @close="closePopup"
    :key="config.appointmentId"
  >
    <div class="w-full">
      <vs-row class="w-full">
        <vs-col vs-w="2">Staff</vs-col>
        <vs-col vs-w="10">
          <v-select
            label="name"
            v-model="provider"
            :options="staffs"
            :clearable="false"
            :searchable="false"
            class="w-full"
            placeholder="Select staff..."
          ></v-select>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-col vs-w="2">Date/Time</vs-col>
        <vs-col vs-w="10">
          <div class="flex">
            <datepicker
              id="view-block-time-datepicker"
              ref="datepicker"
              class="font-bold w-1/2 mr-2"
              v-model="date"
            ></datepicker>
            <v-select
              label="text"
              :options="times"
              :clearable="false"
              :searchable="false"
              class="w-1/2 ml-2"
              v-model="time"
              placeholder="Select time..."
            ></v-select>
          </div>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-col vs-w="2">Duration</vs-col>
        <vs-col vs-w="5">
          <vx-input-group class="mr-2">
            <vs-input v-model="hours" placeholder type="number" />
            <template slot="append">
              <div class="append-text bg-primary">
                <span>hours</span>
              </div>
            </template>
          </vx-input-group>
        </vs-col>
        <vs-col vs-w="5">
          <vx-input-group class="ml-2">
            <vs-input v-model="minutes" placeholder type="number" />
            <template slot="append">
              <div class="append-text bg-primary">
                <span>minutes</span>
              </div>
            </template>
          </vx-input-group>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <!-- <vs-input type="textarea" label="Note" placeholder="Note for customer" /> -->
        <vs-col vs-w="2">Note</vs-col>
        <vs-col vs-w="10">
          <vs-textarea v-model="note" height="200" />
        </vs-col>
      </vs-row>
      <div class="w-full flex justify-center">
        <vs-button @click="saveBlockTime">Save</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";

export default {
  name: "block-time-popup",
  components: {
    Datepicker,
    "v-select": vSelect
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if (this.config.isActive) {
          document.body.classList.add("overflow-hidden");
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    saveBlockTime() {
      if (this.provider != "" && this.provider.user_id && this.hours * 60 + this.minutes > 0) {
        let form = {
          employee_id: this.provider.user_id,
          date: this.date,
          start_time: this.time,
          duration: this.hours * 60 + this.minutes,
          note: this.note
        };
        this.$store
          .dispatch("appointment/CREATE_BLOCK_TIME", form)
          .then(() => {
            this.$vs.notify({
              title: "Success",
              text: "Block time created successfully!",
              color: "success",
              position: "top-right"
            });
            this.closePopup();
          })
          .catch(() => {
            this.$vs.notify({
              title: "Fail",
              text: "Create Block time failed!",
              color: "danger",
              position: "top-right"
            });
            // console.log(error);
          });
      } else {
        this.$vs.notify({
          title: "Fail",
          text: "Please select staff and duration!",
          color: "danger",
          position: "top-right"
        });
      }
    }
  },
  computed: {
    staffs() {
      return this.$store.getters["staff/list"];
    },
    times() {
      return this.$store.getters["appointment/arrayTime"]();
    }
  },
  data() {
    return {
      provider: "",
      note: "",
      hours: 0,
      minutes: 0,
      time: {
        text: "07:00am",
        value: 25200
      },
      date: moment().format("dddd, DD MMM YYYY")
    };
  }
};
</script>

<style lang="scss">
.vdp-datepicker input {
  padding: 0.55rem;
}
</style>